/* eslint-disable camelcase */
import { w as wchar } from '../spchars';
import { parseClass, parseAttrs, clsId } from '../tools';

export const ilb_itag_ila_iclass = [/([[\\]?)(-+|\++|%+|\*+|_+|\^+|`+|~+|==+|\$+)/,
  '(?:', /(\])/, '|', clsId, '|)'];

export function inlineTag(state, p) {
  if (p.ilb === '\\') return state.log(p.match.substr(1));
  if (p.itag === '-' && p.la === '\n') return state.log(p.match);
  if (wchar(p.ilb || p.lb) && wchar(p.ila || p.la)) {
    return state.log(p.match);
  }
  const [itag2, tclass] = iTagRepl(p.itag);
  const closer = state.findOpen('i', itag2);
  if (closer) {
    state.closeTag(closer);
    if (p.iclass) state.log(p.iclass);
  } else {
    if (state.xMode()) return state.log(p.match);
    state.startTag(itag2,
      Object.assign(parseClass({}, tclass), parseAttrs(p.iclass, '', itag2, state)),
      { alt: p.match, type: 'i' });
  }
}

const itagConv = {
  '*': 'b',
  _: 'i',
  '%': 'span',
  '`': 'code',
  '^': 'sup',
  '^^': 'span.VR',
  '~': 'sub',
  '~~': 'span.red',
  '~~~': 'span.rubric',
  '-': 's',
  '+': 'u',
  '==': 'inotex',
  $: 'a',
  $$: 'img',
};

function iTagRepl(tag) {
  const tag2 = itagConv[tag] || itagConv[tag[0]] || tag;
  return tag2.split(/[.#](.*)/);
}
